/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
import '../../../../../../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "common": {
                            "nested": {
                              "QuickAmounts": {
                                "fields": {
                                  "quickAmountPreference": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.QuickAmounts.QuickAmountPreference",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": "OFF"
                                    }
                                  },
                                  "manualAmounts": {
                                    "type": ".squareup.common.Money",
                                    "id": 2,
                                    "rule": "repeated"
                                  },
                                  "hasManualAmounts": {
                                    "type": "bool",
                                    "id": 3,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  }
                                },
                                "nested": {
                                  "QuickAmountPreference": {
                                    "values": {
                                      "UNKNOWN": 0,
                                      "OFF": 1,
                                      "MANUAL": 2,
                                      "AUTO": 3
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.QuickAmounts && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.QuickAmounts?.nested?.QuickAmountPreference) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE QuickAmounts @ squareup/devicesettings/profiles/v2/model/settings/common/quick_amounts.proto at 19:1
 */
export const QuickAmounts = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.QuickAmounts');
fixType(QuickAmounts);
Builder.createAndAttachToType(QuickAmounts);
/**
 * SOURCE QuickAmountPreference @ squareup/devicesettings/profiles/v2/model/settings/common/quick_amounts.proto at 21:3
 */
QuickAmounts.QuickAmountPreference = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.common.QuickAmounts.QuickAmountPreference').values;